<form [formGroup]="addRecordForm" (ngSubmit)="addRecord()">
  <div class="row">
    <div class="form-group col-md-4">
      <label>
        Title <span class="text-danger small">(required)</span>
        <i class="fa fa-question-circle ms-1" data-bs-toggle="tooltip" data-placement="top" data-delay="300" title="Briefly describe this activity"></i>
      </label>
      <input type="text" class="form-control" [ngClass]="setClassInvalid(addRecordForm, 'title')" formControlName="title" placeholder="Title" maxlength="140">
    </div>
    <div class="form-group col-md-4">
      <label>
        You or Assignee <span class="text-danger small">(required)</span>
        <i class="fa fa-question-circle ms-1" data-bs-toggle="tooltip" data-placement="top" data-delay="300" title="Assign this record to another member (if you have the permission to do so)"></i>
      </label>
      <select class="form-control" formControlName="_user" [ngClass]="setClassInvalidAndCanAssignRecord(addRecordForm, '_user')" id="you-or-assignee-select" required>
        <option value="" selected>Select team member</option>
        @for (member of team; track member) {
          <option [value]="member._id">{{member.lastName}} {{member.firstName}}</option>
        }
      </select>
    </div>
    <div class="form-group col-md-4">
      <label class="me-1">Other team members:</label>
      <input type="hidden" class="form-control" formControlName="_users">
      <app-search-input model="user"></app-search-input>
    </div>
  </div>
  <div class="row">
    <div class="form-group col-md-4">
      <label>
        Activity type <span class="text-danger small">(required)</span>
        <span data-bs-toggle="modal" data-bs-target="#record-type-info-modal">
          <i class="fa fa-question-circle ms-1"></i>
        </span>
      </label>
      <select class="form-control" [ngClass]="setClassInvalid(addRecordForm, 'activity')" formControlName="activity" required>
        <option value="" selected disabled>Select activity type</option>
        @for (activity of activities; track activity) {
          <option [value]="activity">{{activity}}</option>
        }
      </select>
    </div>
    <div class="form-group col-md-4">
      <label>Status <span class="text-danger small">(required)</span></label>
      <select class="form-control" [ngClass]="setClassInvalid(addRecordForm, 'status')" formControlName="status" required>
        <option value="" selected disabled>Select status</option>
        @for (status of statuses; track status) {
          <option [value]="status">{{status}}</option>
        }
      </select>
    </div>
    <div class="form-group col-md-4">
      <label>Due date <span class="text-danger small">(required)</span></label>
      <input type="date" class="form-control" [ngClass]="setClassInvalid(addRecordForm, 'date')"
        formControlName="date" [pattern]="dateRegexp" placeholder="YYYY-MM-DD" required>
    </div>
  </div>
  <div class="row">
    <div class="form-group col-md-4">
      <label class="me-1">Stakeholders:</label>
      <input type="hidden" class="form-control" formControlName="_politicians">
      <app-search-input model="politician"></app-search-input>
    </div>
    <div class="form-group col-md-4">
      <label class="me-1">Clients <span class="text-danger small">(required)</span>:</label>
      <input type="hidden" class="form-control" formControlName="_clients">
      <app-search-input model="client" placeholder="Name"></app-search-input>
    </div>
    <div class="form-group col-md-4">
      <label class="me-1">Organizations:</label>
      <input type="hidden" class="form-control" formControlName="_organizations">
      <app-search-input model="organization" placeholder="Name"></app-search-input>
    </div>
  </div>
  <div class="row">
    <div class="form-group col-md-6">
      <label>Client's participants</label>
      <textarea class="form-control" rows="5" [ngClass]="setClassInvalid(addRecordForm, 'clients')"
      formControlName="clients" placeholder="Client's participant names and roles"></textarea>
    </div>
    <div class="form-group col-md-6">
      <label>
        Notes <span class="text-danger small">(required)</span>
        <a class="ms-2 small" [routerLink]="" (click)="addListItem('todo')" tabindex="-1"><i class="fa fa-square-o"></i> Add todo</a>
        <a class="ms-2 small" [routerLink]="" (click)="addListItem('done')" tabindex="-1"><i class="fa fa-check-square-o"></i> Add done</a>
        <a class="ms-2 small" [routerLink]="" (click)="addListItem('hours')" tabindex="-1"><i class="fa fa-clock-o"></i> Add hours</a>
        <a class="ms-2 small" [routerLink]="" (click)="addListItem('main task')" tabindex="-1"><i class="fa fa-circle-o"></i> Add main task</a>
        <a class="ms-2 small" [routerLink]="" (click)="addListItem('main task completed')" tabindex="-1"><i class="fa fa-dot-circle-o"></i> Add main task completed</a>
      </label>
      <textarea class="form-control" rows="5" [ngClass]="setClassInvalid(addRecordForm, 'notes')"
      formControlName="notes" placeholder="Activity description and details.&#10;- [ ] todo 1&#10;- [ ] todo 2&#10;- [x] done 1" required></textarea>
    </div>
  </div>
  <div class="row">
    <div class="form-group col-md-3">
      <label>Google Drive URL</label>
      <input type="url" class="form-control" [ngClass]="setClassInvalid(addRecordForm, 'driveurl')"
        formControlName="driveurl" [pattern]="urlRegexp" placeholder="https://drive.google.com/abc123">
      </div>
      <div class="form-group col-md-3">
        <label>External URL 1</label>
        <input type="url" class="form-control" [ngClass]="setClassInvalid(addRecordForm, 'externalurl')"
          formControlName="externalurl" [pattern]="urlRegexp" placeholder="https://example.com">
        </div>
        <div class="form-group col-md-3">
          <label>External URL 2</label>
          <input type="url" class="form-control" [ngClass]="setClassInvalid(addRecordForm, 'externalurl2')"
            formControlName="externalurl2" [pattern]="urlRegexp" placeholder="https://example.com">
          </div>
          <div class="form-group col-md-3">
            <label>Meeting feedback</label>
            <select class="form-control" tabindex="-1" [ngClass]="{ 'disabled': !addRecordForm.get('activity').value.includes('Meeting'), 'is-touched': addRecordForm.get('feedback').value }"
              formControlName="feedback">
            <option value="" selected>Select meeting feedback</option>
            @for (feedback of feedbacks; track feedback; let index = $index) {
              <option [value]="feedback">
                {{feedback}}
                @for (i of feedbacks.slice(-index - 1); track i) {
                  <span>&#x2605;</span>
                }
              </option>
            }
          </select>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-4">
          <label>Follow up required</label>
          <select class="form-control" [ngClass]="setClassInvalid(addRecordForm, 'followup')" formControlName="followup">
            <option value="" selected>Select follow up</option>
            <option value="yes">Yes</option>
            <option value="no">No</option>
          </select>
        </div>
        <div class="form-group col-md-4" [ngClass]="{ 'disabled': addRecordForm.get('followup').value !== 'yes' }">
          <label>Follow up notes @if (addRecordForm.get('followup').value === 'yes') {
            <span class="text-danger small">(required)</span>
          }</label>
          <textarea class="form-control" rows="3" tabindex="-1" [ngClass]="setClassInvalid(addRecordForm, 'followupnotes')"
          formControlName="followupnotes" placeholder="Follow up notes"></textarea>
        </div>
      </div>
      @if (addRecordForm.get('activity').value === 'UTOPIA Studios - URANIA') {
        <div class="row">
          <div class="form-group col-md-4">
            <label>Format <span class="text-danger small">(required)</span></label>
            <select class="form-control" [ngClass]="setClassInvalid(addRecordForm, 'format')" formControlName="format">
              <option value="" selected>Select format</option>
              @for (format of formats; track format) {
                <option [value]="format">{{format}}</option>
              }
            </select>
          </div>
          <div class="form-group col-md-4">
            <label>Moderator <span class="text-danger small me-1">(required)</span></label>
            <i class="fa fa-info-circle" data-bs-toggle="tooltip" data-placement="top" data-delay="300" title="Add the moderator to Stakeholders or Team members too"></i>
            <input type="text" class="form-control" [ngClass]="setClassInvalid(addRecordForm, 'moderator')" formControlName="moderator" placeholder="Moderator name">
          </div>
        </div>
      }
      <div class="row">
        <div class="form-group col-md-12">
          <button class="btn btn-primary d-block" type="submit" [disabled]="isFormInvalid()">
            <i class="fa fa-plus-circle"></i> Add record
          </button>
        </div>
      </div>
    </form>